import { Component, OnInit, OnDestroy, OnChanges } from "@angular/core";
import { StyleService } from "app/infrastructure/services/style.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
  BreadcrumbService,
  BreadcrumbComponent
} from "ng2-breadcrumb/app/app.module";
import { EntitiesInformationService } from "./entity-information.service";
import { Location } from "@angular/common";
import { EntitiesService } from "../entity/service/entities.service";
import { SxContextService } from "app/infrastructure/services/sxContext.service";

@Component({
  selector: "entity-information",
  templateUrl: "./entity-information.component.html"
})
export class EntityInformationComponent extends BreadcrumbComponent implements OnInit, OnChanges {
  description: String;
  context: {
    channelCode: string;
    subscriptionCode: string;
    productCode: string;
    organizationCode: string;
  };

  constructor(
    private styleService: StyleService,
    private entitiesService: EntitiesService,
    private sxContext: SxContextService,
    public aRoute: ActivatedRoute,
    public routerEntity: Router,
    public informationService: EntitiesInformationService,
    public location: Location,
    router: Router,
    breadcrumbService: BreadcrumbService
  ) {
    super(router, breadcrumbService);
  }

  ngOnInit(): void {
    this.sxContext.getContext(this.aRoute).subscribe(context => {
      this.context = context
    });
    
    this.styleService.addStyle(
      "EntityInformationComponent",
      require("./entity-information.component.css")
    );
  }

  breadcrumUrl() {
   
    return this._urls.filter(
      x =>
        !(
          this.isLast(x, "/soc") ||
          // this.isLast(x, "/organizations") ||
          this.isLast(x, "/subscriptions") ||
          this.isLast(x, "/channels") ||
          this.isLast(x, "/products")
        )
    );
  }

  isLast(route, element) {
    const elementIndex = route.lastIndexOf(element);

    if (elementIndex > -1) {
      const routeLength = route.length;
      const elementLength = element.length;
      const validator = routeLength - elementLength;

      return validator === elementIndex;
    }

    return false;
  }

  goBack() {
    this.location.back();
  }

  settings() {
    this.routerEntity.navigate([this.routerEntity.url + "/edit"]); // Bloqueamos el edit en caso de Organizations
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sidebar-information/entity-information.component.ts